import { GridColumns } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { filterOperators } from '../../../../constants';
import { baseCell } from '../cells/base-cell';

export const EquipmentAccessorColumns = (): GridColumns => {
  const translationPrefix = 'entities.accessor';
  const { t } = useTranslation();

  const columns = [
    {
      field: 'code',
      headerName: t(`${translationPrefix}.code`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`${translationPrefix}.description`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'serial_number',
      headerName: t(`${translationPrefix}.serial_number`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    }
  ];

  return columns;
};
